export const getHttpMethod = (action: string): string => {
  switch (action) {
    case "add":
      return "POST";
    case "edit":
      return "PUT";
    case "delete":
      return "DELETE";
    default:
      return "PUT";
  }
};
